import React from 'react';
import styled from 'styled-components';
import { Flex } from 'grid-styled';
import { minWidth, maxWidth } from 'styled-system';
import { H3 } from './heading';

const StyledSection = styled(Flex)`
    ${minWidth};
    ${maxWidth};

    & > ${H3} {
        border-left: 2px solid red;
        padding-left: 10px;
        margin-left: -12px;
    }
`;

StyledSection.propTypes = {
    ...minWidth.propTypes,
    ...maxWidth.propTypes
};

const Section = ({ title, children, ...props }) => (
    <StyledSection {...props}>
        <H3>{title}</H3>
        {children}
    </StyledSection>
);

Section.defaultProps = {
    pl: 3,
    flexDirection: 'column',
    width: [1, 1 / 2]
};

export default Section;



// WEBPACK FOOTER //
// ./src/uic/Section.js